export default __webpack_public_path__ + "static/media/Ayush.02837b44.png";